import { type FormEvent, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/AuthContext';
import styles from './SuperAdminLogin.module.css';

export default function SuperAdminLogin() {
  const [email, setEmail] = useState('super@admin.com');
  const [password, setPassword] = useState('superadmin');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { superAdminLogin, isAuthenticated, isSuperAdmin } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return <Navigate to={isSuperAdmin ? '/super-admin' : '/dashboard'} replace />;
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await superAdminLogin(email, password);
      navigate('/super-admin');
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logo}>CtrlEscolar</div>
        <p className={styles.subtitle}>Panel de Super Administrador</p>
        {error && <div className={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit} className={styles.form}>
          <input
            className={styles.input}
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            className={styles.input}
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading} className={styles.submitBtn}>
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        <div className={styles.badge}>Solo para administradores del sistema</div>
      </div>
    </div>
  );
}
